import React from 'react'
import ReconciliationsTableHeader from './ReconciliationsTableHeader'
import ReconciliationRow from './ReconciliationRow'
import { Table } from 'semantic-ui-react'
import SplitClient from "../../utils/splitClient";
import * as sessionHelpers from "../../helpers/sessionHelpers";

export default class ReconciliationsTable extends React.Component {
    state = {
        version: ''
    }

    async componentDidMount() {
        const treatment = await SplitClient.getTreatment("SHOP_ORDERS", {email: sessionHelpers.getApplicationCookie('current_user_email')})
        this.setState({version: treatment.SHOP_ORDERS})
    }

    render() {
        const {orders, sortableHeaderCell} = this.props

        return (
            <React.Fragment>
                <Table.Header>
                    <ReconciliationsTableHeader sortableHeaderCell={sortableHeaderCell} />
                </Table.Header>
                <Table.Body>
                    {orders.map((order, i) => {
                        const { originator, vehicle, shop, order_services } = order

                        return (
                            <ReconciliationRow
                                key={`reconciliation-order-row-${i + 2}`}
                                order={order}
                                originator={originator}
                                vehicle={vehicle}
                                shop={shop}
                                orderServices={order_services}
                                isLastRow={i === orders.length - 1}
                                version={this.state.version}
                            />
                        )
                    })}
                </Table.Body>
            </React.Fragment>
        )
    }
} // ReconciliationsTable
